<li class="p-2 gap-y-2 cursor-pointer flex flex-col shrink-0 shadow-card-container-pale">

    <cc-creator-column-generic [creator]="creator" [searchColour]="'pink'"></cc-creator-column-generic>

    <!-- Portfolio Card -->
    <div class="bg-white/50 dark:bg-white/5 rounded-lg p-2 flex flex-col gap-y-2 shadow overflow-hidden h-full">
        <h4 class="text-xs font-bold text-primary shrink-0">Matching Content</h4>


        @if (creator.videos && creator.videos.length > 0) {
        <ul role="list" class="grid grid-cols-3 gap-x-2 gap-y-4 w-full">
            @for (video of creator.videos.slice(0, 3); track $index) {
            <li (click)="videoPreview(video)" class="relative">
            <!-- <li class="relative"> -->
                <div
                    class="w-full aspect-9/16 overflow-hidden rounded-lg cursor-pointer group bg-gray-100 focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary">
                    <atom-video-thumbnail [videoUrl]="video.video_file.s3_url" 
                        [thumbnailURL]="video.video_file.cover && video.video_file.cover.length !== '' ? video.video_file.cover : undefined"
                        [videoFormat]="VideoFormatEnum.Vertical" [thumb_cdn_size]="'gallery'"></atom-video-thumbnail>
                    <!-- (click)="openViewer($event)"></vs-video-thumbnail> -->
                </div>
            </li>
            }
        </ul>
        }
        @else {
        <div class="flex h-full items-center">
            <span
                class="inline-flex items-center gap-x-1.5 rounded-full bg-primary/10 px-2 py-1 text-xxs font-medium text-accent">
                <svg class="size-1.5 fill-primary" viewBox="0 0 6 6" aria-hidden="true">
                    <circle cx="3" cy="3" r="3" />
                </svg>
                No Matching Content
            </span>
        </div>
        }
    </div>
    <!-- Portfolio Card -->
</li>